import { tailwindVariants } from '@air/utils-tailwind';

/**
 * Matches Strato prototype filter chips. Applied via `ui2026:` so flag-off chrome is unchanged.
 */
export const ui2026FilterChip = tailwindVariants({
  base: 'ui2026:rounded-6 ui2026:font-medium',
  defaultVariants: {
    isActive: false,
  },
  variants: {
    isActive: {
      false:
        'ui2026:border ads:border-ads-gray-5 ui2026:border-gray-5 ui2026:bg-transparent ads:text-primary ui2026:text-gray-12 ads:hover:bg-hover-subtle ui2026:hover:bg-gray-5 ads:active:bg-hover-subtle ui2026:active:bg-gray-4',
      true: 'ui2026:border ads:border-primary ui2026:border-altitude-11 ui2026:bg-transparent ads:text-accent ui2026:text-altitude-11 ads:hover:bg-primary-subtle ui2026:hover:bg-altitude-3 ads:active:bg-primary-subtle ui2026:active:bg-altitude-3 ads:group-hover:bg-primary-subtle ui2026:group-hover:bg-altitude-3',
    },
  },
});

/** Idle "+ More" is a ghost control, not an outlined chip. */
export const ui2026MoreFiltersIdle = tailwindVariants({
  base: 'ui2026:rounded-6 ui2026:font-medium ads:text-primary ui2026:text-gray-12',
});

export const ui2026FiltersBar = tailwindVariants({
  base: 'ui2026:flex-nowrap ui2026:gap-1',
});

/**
 * Flag-off keeps p-4. ui2026 uses py-2 so chips sit in the same 48px row as Search all
 * (py-2 around h-8) and drops left padding because the sticky/topbar wrapper already pads.
 */
export const ui2026FiltersBarPadding = tailwindVariants({
  base: 'p-4 ui2026:py-2 ui2026:pl-0',
});

/** Ghost close on a selected chip: default `hover:bg-blue-1` is too faint. */
export const ui2026FilterChipClose = tailwindVariants({
  base: 'ads:hover:bg-ads-altitude-4 ui2026:hover:bg-altitude-4 ads:active:bg-ads-altitude-5 ui2026:active:bg-altitude-5',
});
